namespace Portico.Models {
    export class ChildSessionData {
        public portalId: string;
        public features: string[];
        public jwt: string;

        constructor(obj?: any) {
            this.portalId = null;
            this.features = [];
            this.jwt = null;
            
            if (obj) {
                this.portalId = obj.portalId || null;
                this.features = obj.features || [];
                this.jwt = obj.jwt || null;
            }
        }
    }
}